const ID_TOKEN = 'id_token';
const USER_DATA = 'usrd';

const auth = {
  isLoggedIn: false,
  isAuthenticated() {
    const token = this.getToken();
    this.isLoggedIn = !!token;
    return this.isLoggedIn;
  },
  setToken(idToken:string) {
    this.setUserData(idToken);
    localStorage.setItem(ID_TOKEN, idToken);
    this.isLoggedIn = true;
  },
  getToken() {
    return localStorage.getItem(ID_TOKEN);
  },
  getEmail() {
    const userData = this.getUserData();
    return userData.email;
  },
  setImageUrl(txt:string) {
    localStorage.setItem("imageUrl", txt);
  },
  getImageUrl() {
    const userData = this.getUserData();
    return userData.picture_url;
  },
  setUserData(token:string) {
    let data;
    try {
      data = JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      console.log(e);
    }
    localStorage.setItem(USER_DATA, JSON.stringify(data));
  },
  getUserData() {
    try {
      let userData = JSON.parse(localStorage.getItem(USER_DATA) || '');
      if (!userData || !userData.name) {
        const token = this.getToken();
        if (token) {
          this.setUserData(token);
          userData = this.getUserData();
        }
      }
      return userData;
    } catch (err) {
      return {};
    }
  },
  getUserName() {
    const userData = this.getUserData();
    return userData.name;
  },
  clear() {
    localStorage.removeItem(ID_TOKEN);
    localStorage.removeItem(USER_DATA);
    this.isLoggedIn = false;
  }
}

export default auth;